import React from 'react'
import Orders from 'pages/app/inventory/Orders'
import { Translator } from '@morningtrain/react-translations'
import AdminPage from "pages/app/AdminPage";

export default function Delivery (props) {

  return (
    <AdminPage>
      <Translator namespace='inventory.delivery'>
        <Orders/>
      </Translator>
    </AdminPage>
  )
}
